module.exports = __webpack_public_path__ + "static/media/jawcore-logo.0e148b0c.jpg";